<template>
<div class="thumbnail-editor" v-if="item.media">
  <h3>Select Thumbnail</h3>
  <ul class="thumbs">
    <li v-for="(thumb, ti) in thumbs" :class="{active: item.media.thumbnail==thumb}" v-on:click.prevent="select(thumb)">
      <img :src="posterUrl(thumb)" />
<!--       <div class="overlay"><span></span><span></span><span></span><span></span></div> -->
    </li>
  </ul>
  <div class="activethumb">
    <thumbnail-crop :src="posterUrl()" ref="thumbCrop" :crop.sync="currentCrop"></thumbnail-crop>
<!--     <img :src="posterUrl()" /> -->
<!--     <div class="overlay"><span></span><span></span><span></span><span></span></div> -->
  </div>
  <div class="uploader">
    <label><span></span></label>
    <input type="file" ref="filechooser" v-on:change="uploadFile" />
  </div>
  <div class="save-crop" v-if="currentCrop" v-on:click.prevent="saveCrop">
    <label><span></span></label>
  </div>
</div>
</template>

<script>
export default {
  props: ["item"],
  data: ()=>({
    thumbs: [],
    currentCrop: null,
  }),
  watch: {
    "item.media":{
      handler() {
        var media=this.item.media;
        if (!media || !media.store || media.store.plugin!="Video2")
          return this.thumbs=[];
        var path=(media.thumbnail || "").replace(/\/[^/]+$/, "/");
        this.thumbs=[path+"preview.jpg", path+"preview0.jpg", path+"preview1.jpg", path+"preview2.jpg"];
      }, immediate: true,
    },
  },
  methods: {
    posterUrl(custom) {
      if (custom)
        return custom;
      if (!custom && this.item.thumbnail) {
        return this.photoLink(this.item.thumbnail);
      }
      var media=this.item.media;
      if (!media || !media.store || media.store.plugin!="Video2")
        return null;
      return media.thumbnail;
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    uploadFile($event) {
      var file=$event.target.files[0];
      if (!file)
        return;
      this.uploadImage(file);
    },
    select(thumb) {
      this.item.media.thumbnail=thumb;
      this.item.newThumbnail=null;
      this.item.thumbnail=null;
    },
    async uploadImage(file) {
      var result=await api.create("Media", {store: 1});
      if (result.id) {
        await api.upload("Media", result.id, file);
      }
      var media=(await api.get("Media", result.id)).item;
      this.$set(this.item, "thumbnail", media);
      this.$set(this.item, "newThumbnail", result.id);
    },
    async saveCrop() {
      var result=await api.create("Media", {store: 1});
      if (result.id) {
        await api.upload("Media", result.id, this.currentCrop, {filename: "crop-"+((new Date()).getTime())+".jpg"});
      }
      var media=(await api.get("Media", result.id)).item;
      this.$set(this.item, "thumbnail", media);
      this.$set(this.item, "newThumbnail", result.id);
      this.currentCrop=null;
      this.$emit("done");
    },
  },
}
</script>
